import React, { useState } from 'react';
import { MessageOutlined, CloseOutlined, PhoneOutlined, MailOutlined } from '@ant-design/icons';
import { useLanguage } from '@/hooks/useLanguage';
import styles from './CustomerService.module.scss';

const CustomerService: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useLanguage();

  const toggleChat = () => {
    setIsOpen(!isOpen);
  };

  const handlePhoneClick = () => {
    window.open('tel:+86-400-123-4567');
  };

  const handleEmailClick = () => {
    window.open('mailto:service@changmei.com');
  };

  return (
    <div className={styles.customerService}>
      {/* 聊天窗口 */}
      {isOpen && (
        <div className={styles.chatWindow}>
          <div className={styles.chatHeader}>
            <h3>{t('customerService.title')}</h3>
            <button onClick={toggleChat} className={styles.closeButton}>
              <CloseOutlined style={{ fontSize: '20px' }} />
            </button>
          </div>
          <div className={styles.chatContent}>
            <p>{t('customerService.welcome')}</p>
            <div className={styles.contactOptions}>
              <button onClick={handlePhoneClick} className={styles.contactButton}>
                <PhoneOutlined style={{ fontSize: '16px' }} />
                <span>{t('customerService.phone')}</span>
              </button>
              <button onClick={handleEmailClick} className={styles.contactButton}>
                <MailOutlined style={{ fontSize: '16px' }} />
                <span>{t('customerService.email')}</span>
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 悬浮按钮 */}
      <button
        className={styles.floatingButton}
        onClick={toggleChat}
        aria-label={t('customerService.title')}
      >
        <MessageOutlined style={{ fontSize: '24px' }} />
      </button>
    </div>
  );
};

export default CustomerService;